<script>
import LogDetailsMixin from './log-details.mixin.js'

export default {
  name: 'OfferLogDetails',
  mixins: [LogDetailsMixin],
  computed: {
    offerClassification() {
      const { feed_offer: feedOffer } = this.metadata.offer

      if (feedOffer) {
        const categoriesList = feedOffer.map.categories

        if (!categoriesList.length) {
          return '—'
        }

        return categoriesList
          .map(cat => cat.name)
          .join(', ')
      }

      return '—'
    },
  },
}
</script>

<template>
  <expanded-row :columns="columns">
    <template v-if="action === 'action_delete_offer'">
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Global Merchant Name
        </div>
        <div :class="$style.subrow">
          Classification
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.offer.global_merchant.name }}
        </div>
        <div :class="$style.subrow">
          {{ offerClassification }}
        </div>
      </div>
    </template>
  </expanded-row>
</template>

<style lang="scss" module>
.subrow {
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
